import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

// Read-only endpoints the public website uses (no login).
export const publicCountriesApi = {
  getAll: async (search = '') => {
    const response = await axios.get(`${API_URL}/api/countries`, {
      params: { search }
    });
    return response.data;
  },

  getByName: async (name) => {
    const response = await axios.get(`${API_URL}/api/countries/${name}`);
    return response.data;
  }
};

// Number coverage and prices from the imported price lists (selling prices in pence).
export const publicCoverageApi = {
  // type: optional kind (local, national, mobile, 2way, uc, tollfree, uifn) or group (did, tollfree, uifn)
  list: async (type) => {
    const response = await axios.get(`${API_URL}/api/public/coverage`, { params: type ? { type } : {} });
    return response.data;
  },

  country: async (name) => {
    const response = await axios.get(`${API_URL}/api/public/coverage/${encodeURIComponent(name)}`);
    return response.data;
  },

  // kind: all, did, tollfree or uifn
  pdfUrl: (kind = 'all') => `${API_URL}/api/public/coverage/download/${kind}.pdf`,
};
